<template>
  <tapout-component
      class="tapout"
      :style="{
			width: `${width + dw}px`,
			height: `${Math.round((width + dw) / ratio)}px`,
			transform: `translate(${x + dx}px, ${y + dy}px)`,
		}"
      @tapout="onBlur"
      @onClick="$emit('onClick')"
  >
    <div
        class="drag-layer"
        :class="[
				operation === 'move' ? 'dragging' : '',
				operation ? 'operation' : '',
			]"
        @mousedown="handlePanStart"
        @touchstart="handlePanStart"
    >
      <div
          data-direction="left-top"
          class="tapout-selector resize-nwse"
          :style="{position: 'absolute', top: '0%', left: '0%' }"
          v-show="edit"
      />
      <div
          data-direction="right-top"
          class="tapout-selector resize-nesw"
          :style="{position: 'absolute', top: '0%', left: '100%' }"
          v-show="edit"
      />
      <div
          data-direction="left-bottom"
          class="tapout-selector resize-nesw"
          :style="{position: 'absolute', top: '100%', left: '0%' }"
          v-show="edit"
      />
      <div
          data-direction="right-bottom"
          class="tapout-selector resize-nwse"
          :style="{position: 'absolute', top: '100%', left: '100%' }"
          v-show="edit"
      />
    </div>
    <canvas
        ref="imgCanvas"
        class="canvas"
        :class="[edit === true ? 'canvas-edit': '']"

        @focus="onFocus"
        @keydown="onFocus"
    />
  </tapout-component>
</template>

<script>
import itemEventsMixin from "./ItemEventsMixin";
import TapoutComponent from "./Tapout.vue";

export default {
  name: "ImageComponent",
  components: {TapoutComponent},
  mixins: [itemEventsMixin],
  props: [
    "payload",
    "file",
    "width",
    "height",
    "originWidth",
    "originHeight",
    "x",
    "y",
    "pageScale"
  ],
  data() {
    return {
      startX: null,
      startY: null,
      canvas: null,
      operation: "",
      directions: [],
      dx: 0,
      dy: 0,
      dw: 0,
      dh: 0,
      edit: false,
    };
  },
  computed: {
    ratio() {
      return this.originWidth / this.originHeight;
    },
  },
  watch: {
    async file(value) {
      value && (await this.render());
    },
  },
  async mounted() {
    await this.render();
  },
  methods: {
    async render() {
      // use canvas to prevent img tag's auto resize
      const canvas = this.$refs.imgCanvas;
      canvas.width = this.originWidth * 12;
      canvas.height = this.originHeight * 12;
      canvas.getContext("2d").drawImage(this.payload, 0, 0, canvas.width, canvas.height);
      this.edit = true;
    },
    async onBlur() {
      this.operation = "";
      this.edit = false;
      // this.$emit("onUpdate", {
      //   x: this.x + this.dx,
      //   y: this.y + this.dy
      // });
    },
    onFocus() {
      this.operation = "edit";
      this.edit = true;
      // this.$emit("onUpdate", {
      //   x: this.x + this.dx,
      //   y: this.y + this.dy
      // });
    },
    handlePanMove(event) {
      this.edit = true;
      let coordinate;
      if (event.type === "mousemove") {
        coordinate = this.handleMousemove(event);
      }
      if (event.type === "touchmove") {
        coordinate = this.handleTouchmove(event);
      }
      if (!coordinate) return console.log("ERROR");

      const _dx = (coordinate.detail.x - this.startX) / this.pageScale;
      const _dy = (coordinate.detail.y - this.startY) / this.pageScale;
      if (this.operation === "move") {
        this.dx = _dx;
        this.dy = _dy;
      } else if (this.operation === "scale") {
        if (this.directions.includes("left")) {
          this.dx = _dx;
          this.dw = -_dx;
        }
        if (this.directions.includes("top")) {
          this.dy = _dy;
          this.dh = -_dy;
        }
        if (this.directions.includes("right")) {
          this.dw = _dx;
        }
        if (this.directions.includes("bottom")) {
          this.dh = _dy;
        }
      }
    },

    handlePanEnd(event) {
      this.edit = true;
      let coordinate;
      if (event.type === "mouseup") {
        coordinate = this.handleMouseup(event);
      }
      if (event.type === "touchend") {
        coordinate = this.handleTouchend(event);
      }
      if (!coordinate) return console.log("ERROR");
      if (this.operation === "move") {
        this.$emit("onUpdate", {
          x: this.x + this.dx,
          y: this.y + this.dy
        });

        this.dx = 0;
        this.dy = 0;
      } else if (this.operation === "scale") {
        this.$emit("onUpdate", {
          x: this.x + this.dx,
          y: this.y + this.dy,
          width: this.width + this.dw,
          height: Math.round((this.width + this.dw) / this.ratio)
        });

        this.dx = 0;
        this.dy = 0;
        this.dw = 0;
        this.dh = 0;
        this.directions = [];
      }
      this.operation = "";
    },
    handlePanStart(event) {
      let coordinate;
      if (event.type === "mousedown") {
        coordinate = this.handleMousedown(event);
      }
      if (event.type === "touchstart") {
        coordinate = this.handleTouchStart(event);
      }
      if (!coordinate) return console.log("ERROR");

      this.startX = coordinate.detail.x;
      this.startY = coordinate.detail.y;
      if (coordinate.detail.target === event.currentTarget) {
        return (this.operation = "move");
      }
      this.operation = "scale";
      this.directions =
          coordinate.detail.target.dataset.direction.split("-");
      this.edit = true;
    },
  },
};
</script>

<style scoped lang="css">
.tapout {
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
}

.drag-layer {
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: grab;
}

.dragging {
  cursor: grabbing;
}

.operation {
  background-color: rgba(0, 0, 0, 0.3);
}

.tapout-selector {
  border-radius: 10px;
  width: 12px;
  height: 12px;
  margin-left: -6px;
  margin-top: -6px;
  background-color: #32b5fe;
  border: 1px solid #32b5fe;
}

.resize-nwse {
  cursor: nwse-resize;
}

.resize-nesw {
  cursor: nesw-resize;
}

.canvas {
  width: 100%;
  height: 100%;
}

.canvas-edit {
  border: 1px dashed #f87171;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/pdf-lib-contents/Image.vue